import Vue from 'vue'
import Router from 'vue-router'
import HelloWorld from '@/components/HelloWorld'
import Auth from '@/components/auth'
import Index from '@/components/index'
import Login from '@/components/login'
import UserInfo from '@/components/userInfo'
import UserList from '@/components/userList'
import OrderList from '@/components/orderList'
import AllOrderList from '@/components/allOrderlist'
import AppOrderList from '@/components/apporderList'
import SelectApp from '@/components/select'

Vue.use(Router)

export default new Router({
  routes: [
  	{
      path: '/helloword',
      name: 'helloword',
      component: HelloWorld
    },
    {
      path: '/Auth',
      name: 'auth',
      component: Auth
   	},
   	{
      path: '/',
      name: 'index',
      redirect:'/userinfo',
   	},
   	{
      path: '/login',
      name: 'login',
      component: Login
   	},
   	{
      path: '/userinfo',
      name: 'UserInfo',
      component: UserInfo
   	},
   	{
      path: '/userlist',
      name: 'userlist',
      component: UserList
   	},
   	{
      path: '/orderlist',
      name: 'orderlist',
      component: OrderList
   	 },
    {
      path: '/apporderlist',
      name: 'apporderlist',
      component: AppOrderList
    },
    {
      path: '/allorderlist',
      name: 'allorderlist',
      component: AllOrderList
   	},
    {
      path: '/select',
      name: 'select',
      component: SelectApp
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js